import { createFileRoute } from '@tanstack/react-router';
import { VisitsPage } from '@/modules/visits/public';

export const Route = createFileRoute('/_app/visitas')({
  component: VisitsPage,
});
